import { useTranslations } from 'contexts/Translation'
import PropTypes from 'prop-types'
import {
  Col,
  Container,
  Row,
  Card,
  Text,
  Divider,
  Title,
  Img
} from '@qonsoll/react-design'
import { useHistory } from 'react-router-dom'
import { CardDropdown, SelectableCard } from 'components'
import { useSimpleFormActions } from 'hooks'
import { useParams } from 'react-router-dom'
import { updateParentHasOneRelationship } from 'hooks'

const CustomerProfileSimpleView = (props) => {
  const { customerProfile, onSelect, onDelete, index, isSelected, actions } =
    props

  // [ADDITIONAL_HOOKS]
  const { t } = useTranslations()
  const history = useHistory()
  const { handleDelete: removeDocument } = useSimpleFormActions({
    document: customerProfile,
    collectionName: 'customerProfiles'
  })
  const params = useParams()

  // [HANDLERS]
  const handleOpen = () => {
    history.push(`/customer-profiles/${customerProfile?._id}`)
  }
  const handleEdit = () => {
    history.push(`/customer-profiles/${customerProfile?._id}/edit`)
  }
  const handleDelete = (item, index) => {
    removeDocument()
    if (params.customerId)
      updateParentHasOneRelationship(
        params.customerId,
        'customers',
        'profileId',
        item?._id,
        true
      )
  }
  const handleSelect = (e) => {
    e.stopPropagation()
    onSelect?.(customerProfile?._id)
  }

  return (
    <CardDropdown
      onDelete={handleDelete}
      onEdit={handleEdit}
      onDoubleClick={handleOpen}
      onClick={handleSelect}
      document={customerProfile}
      index={index}
      {...actions}>
      <SelectableCard isSelected={isSelected}>
        <Row
          noGutters
          justifyContent="center"
          alignItems="center"
          py="4px"
          mb={2}>
          <Col>
            <Title level={4}>{t('CustomerProfile')}</Title>
          </Col>
        </Row>
        <Row
          noGutters
          justifyContent="center"
          alignItems="center"
          py="4px"
          mb={2}>
          <Col>
            <Text
              overflow="hidden"
              textOverflow="ellipsis"
              maxWidth="250px"
              whiteSpace="nowrap">
              {customerProfile?.description}
            </Text>
          </Col>
        </Row>
        <Row
          noGutters
          justifyContent="center"
          alignItems="center"
          py="4px"
          mb={2}>
          <Col>
            <Text
              overflow="hidden"
              textOverflow="ellipsis"
              maxWidth="250px"
              whiteSpace="nowrap">
              {customerProfile?.isDescriptionChanged}
            </Text>
          </Col>
        </Row>
        <Divider />
        <Row
          noGutters
          justifyContent="center"
          alignItems="center"
          py="4px"
          mb={2}>
          <Col>
            <Text>{t('Notes')}</Text>
          </Col>
          <Col cw="auto">
            <Text
              overflow="hidden"
              textOverflow="ellipsis"
              maxWidth="250px"
              whiteSpace="nowrap">
              {customerProfile?.notes}
            </Text>
          </Col>
        </Row>
      </SelectableCard>
    </CardDropdown>
  )
}

CustomerProfileSimpleView.propTypes = {
  customerProfile: PropTypes.object,
  onSelect: PropTypes.func,
  onDelete: PropTypes.func,
  index: PropTypes.number,
  isSelected: PropTypes.bool,
  actions: PropTypes.shape({
    onEdit: PropTypes.func,
    onDelete: PropTypes.func,
    onDoubleClick: PropTypes.func,
    onClick: PropTypes.func
  })
}

export default CustomerProfileSimpleView
